export default "__VITE_ASSET__BxVCX4pn__"